export const formatNumber = (value, decimalPlaces) => {
    if(isEmpty(value)){
        return "-";
    }else{
        return Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        }).format(value);
    }
}

export const isEmpty = (value) => {
  if (value &&
      value !== null &&
      value !== '' &&
      value !== 'null' &&
      value !== 'undefined' &&
      value !== 0 &&
      value !== '0' &&
      value !== 'false' &&
      value !== Infinity &&
      value !== NaN) {
      return false
  } else {
    return true
  }
}

export const formatNumberWithSymbol = (num) => {
    if (num > 999 && num < 1000000) {
        return (num / 1000).toFixed(1) + "K";
      } else if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + "M";
      } else if (num < 900) {
        return num;
      }
}